export default __webpack_public_path__ + "static/media/backArrow.63dbb22b.svg";